import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg custom-navbar" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "collapse navbar-collapse",
  id: "mainNav"
}
const _hoisted_4 = { class: "navbar-nav mx-auto mb-2 mb-lg-0" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item dropdown" }
const _hoisted_10 = { class: "dropdown-menu custom-dropdown" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "header-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandLogo = _resolveComponent("BrandLogo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["site-header", { 'is-scrolled': $data.scrolled }])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "navbar-brand brand",
          to: "/dashboard"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_BrandLogo, { size: "md" })
          ]),
          _: 1
        }),
        _cache[12] || (_cache[12] = _createElementVNode("button", {
          class: "navbar-toggler",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#mainNav",
          "aria-controls": "mainNav",
          "aria-expanded": "false",
          "aria-label": "باز و بسته کردن منو"
        }, [
          _createElementVNode("i", { class: "bi bi-list" })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/dashboard"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("داشبورد", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/mock-exams"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("آزمون‌های آزمایشی", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/reading-practice"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("ریدینگ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/writing-exercises"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("رایتینگ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _cache[8] || (_cache[8] = _createElementVNode("a", {
                class: "nav-link dropdown-toggle",
                href: "#",
                role: "button",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false"
              }, "اسپیکینگ", -1)),
              _createElementVNode("ul", _hoisted_10, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "dropdown-item",
                    to: "/oral-practice"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("تمرین شفاهی", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "dropdown-item",
                    to: "/spoken-language"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("زبان گفتاری", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "dropdown-item",
                    to: "/Oral-Mock-Tes"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("آزمون شفاهی آزمایشی", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/practice-records"
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("سوابق", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("form", {
              class: "search-form",
              role: "search",
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("i", { class: "bi bi-search" }, null, -1),
              _createElementVNode("input", {
                type: "search",
                placeholder: "جستجوی آزمون...",
                "aria-label": "جستجو"
              }, null, -1)
            ]))], 32),
            _createVNode(_component_router_link, {
              class: "btn login-btn",
              to: "/"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "bi bi-person-circle" }, null, -1),
                _createElementVNode("span", null, "ورود", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 2))
}